import { render } from "./OrderActions.vue?vue&type=template&id=6478b757&scoped=true&ts=true"
import script from "./OrderActions.vue?vue&type=script&lang=ts"
export * from "./OrderActions.vue?vue&type=script&lang=ts"

import "./OrderActions.vue?vue&type=style&index=0&id=6478b757&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6478b757"]])

export default __exports__